/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./password-setup-page.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../password-setup-box/password-setup-box.component.ngfactory";
import * as i3 from "../password-setup-box/password-setup-box.component";
import * as i4 from "../login.service";
import * as i5 from "../../shared/oe-app.service";
import * as i6 from "@angular/forms";
import * as i7 from "@ng-bootstrap/ng-bootstrap";
import * as i8 from "../../shared/window.service";
import * as i9 from "./password-setup-page.component";
var styles_PasswordSetupPageComponent = [i0.styles];
var RenderType_PasswordSetupPageComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_PasswordSetupPageComponent, data: {} });
export { RenderType_PasswordSetupPageComponent as RenderType_PasswordSetupPageComponent };
export function View_PasswordSetupPageComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "lp2-password-setup-box", [], null, null, null, i2.View_PasswordSetupBoxComponent_0, i2.RenderType_PasswordSetupBoxComponent)), i1.ɵdid(1, 114688, null, 0, i3.PasswordSetupBoxComponent, [i4.LoginService, i5.OeAppService, i6.FormBuilder, i7.NgbModal, i8.WindowService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_PasswordSetupPageComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "lp2-password-setup-page", [], null, null, null, View_PasswordSetupPageComponent_0, RenderType_PasswordSetupPageComponent)), i1.ɵdid(1, 49152, null, 0, i9.PasswordSetupPageComponent, [], null, null)], null, null); }
var PasswordSetupPageComponentNgFactory = i1.ɵccf("lp2-password-setup-page", i9.PasswordSetupPageComponent, View_PasswordSetupPageComponent_Host_0, {}, {}, []);
export { PasswordSetupPageComponentNgFactory as PasswordSetupPageComponentNgFactory };
//# sourceMappingURL=password-setup-page.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/login/password-setup-page/password-setup-page.component.ngfactory.js
// module id = 1664
// module chunks = 27 28 29